import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ShareButtons, generateShareIcon } from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import isSameElement from '../../helpers/isSameElement';
import { trackEvent } from '../../utils/analytics/analyticsManager';
import { eventCategory, eventAction, eventLabel } from '../../utils/analytics/analyticsConstants';
import * as styles from './ShareTooltip.scss';

const FacebookIcon = generateShareIcon('facebook');
const WhatsappIcon = generateShareIcon('whatsapp');
const { FacebookShareButton } = ShareButtons;

const whatsAppMessage = {
  he: 'מצאתי דירה מעניינת ב- און מאפ שחשבתי שתעניין אותך:',
  en: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:',
  ru: 'Я нашел интересную квартиру на OnMap.co.il, которая, как я думал, заинтересует вас:',
  fr: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:'
};

const emailMessage = {
  he: { subject: 'דירה מעניינת ב- און מאפ', message: 'מצאתי דירה מעניינת ב- און מאפ שחשבתי שתעניין אותך:' },
  en: { subject: 'Interesting apartment on OnMap.co.il', message: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:' },
  ru: { subject: 'Интересная квартира на OnMap.co.il', message: 'Я нашел интересную квартиру на OnMap.co.il, которая, как я думал, заинтересует вас:' },
  fr: { subject: 'Interesting apartment on OnMap.co.il', message: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:' }
};

export default class ShareTooltip extends Component {
  state = {
    linkCopied: false
  };

  componentDidMount() {
    if (!this.props.isMobile) {
      document.body.addEventListener('click', this.bodyClickHandler);
    }
  }

  componentWillUnmount() {
    if (!this.props.isMobile) {
      document.body.removeEventListener('click', this.bodyClickHandler);
    }
  }

  bodyClickHandler = (evt) => {
    if (!this.props.isTooltipShown) {
      return;
    }
    if (!isSameElement(this.node, evt.target)) {
      evt.stopPropagation();
      this.props.hideTooltip();
    }
  };

  trackShareClick = () =>
    new Promise((resolve) => {
      resolve(trackEvent(eventCategory.share, eventAction.click, eventLabel.contactDetails));
    });

  tooltipClickHandler = () => {
    const { isMobile, hideModalShare, hideTooltip } = this.props;
    const closeTooltip = (isMobile) ? hideModalShare : hideTooltip;

    if (this.closeWithTimeout) {
      setTimeout(closeTooltip, 2000);
    } else {
      closeTooltip();
    }
  };

  handleCopyLink = () => {
    this.closeWithTimeout = true;
    this.setState({ linkCopied: true });
  };

  renderShareEmail = (sharingUrl) => {
    const { subject, message } = emailMessage[this.props.locale];
    const link = `mailto:?subject=${subject}&body=${message} ${sharingUrl}`;
    return (
      <a href={link} className={styles.shareRow}>
        <div className={styles.iconWrapper}>
          <span className="icon icon-mailIcon" />
        </div>

        <span>{this.props.emailTitle}</span>
      </a>
    );
  };

  render() {
    const { sharingData: { sharingUrl }, isMobile } = this.props;
    const protocol = (sharingUrl.includes('://')) ? '' : 'https://';
    const shareText = `${encodeURIComponent(whatsAppMessage[this.props.locale])} ${protocol}${sharingUrl}`;

    const whatsappLink = isMobile
      ? `whatsapp://send?text=${shareText}`
      : `https://api.whatsapp.com/send?text=${shareText}`;
    return (
      <div
        onClick={this.tooltipClickHandler}
        className={cx((isMobile) ? styles.shareWrapper : styles.tooltipWrapper, styles[this.props.className])}
        ref={(node) => { this.node = node; }}
      >
        <div className={styles.shareRow}>
          <FacebookShareButton
            url={protocol + sharingUrl}
            beforeOnClick={this.trackShareClick}
          >
            <div className={styles.iconWrapper}>
              <FacebookIcon size={35} round />
            </div>
            <span>Facebook</span>
          </FacebookShareButton>
        </div>

        <a
          className={styles.shareRow}
          href={whatsappLink}
          target="_blank"
          data-action="share/whatsapp/share"
        >
          <div className={styles.iconWrapper}>
            <WhatsappIcon size={35} round />
          </div>
          <span>WhatsApp</span>
        </a>

        <CopyToClipboard
          text={sharingUrl && `${protocol}${sharingUrl}`.replace(/www./g, '')}
          onCopy={this.handleCopyLink}
        >
          <div className={styles.shareRow}>
            <div className={styles.iconWrapper}>
              <div className={styles.copyLinkWrap}>
                <span className="icon icon-copy-link">
                  <span className="path1" />
                  <span className="path2" />
                  <span className="path3" />
                </span>
              </div>
            </div>
            <div className={styles.copyLink}>
              <span>{this.props.copyLinkTitle}</span>
              { this.state.linkCopied && (
                <span className="icon icon-circled-check" >
                  <span className="path1" />
                  <span className="path2" />
                </span>
              )}
            </div>
          </div>
        </CopyToClipboard>
        {this.renderShareEmail(sharingUrl)}
      </div>
    );
  }
}

ShareTooltip.propTypes = {
  locale: PropTypes.string,
  emailTitle: PropTypes.string,
  className: PropTypes.string,
  copyLinkTitle: PropTypes.string,
  sharingData: PropTypes.object,
  hideTooltip: PropTypes.func,
  isTooltipShown: PropTypes.bool,
  isMobile: PropTypes.bool,
  hideModalShare: PropTypes.func
};
